// @ts-nocheck
document.addEventListener('alpine:init', () => {
  Alpine.data('ProductComponent', () => ({
    product: null,
    selected_variant: null,
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      this.product = JSON.parse(this.$el.dataset.product);
      let selected_variant_id = this.$el.dataset.selected_variant_id;
      this.selected_variant = this.product.variants.find(v => v.id == selected_variant_id);
    },
    InitWatchers() {
      this.$el.addEventListener('change', (e) => {
        let variant_id = e.target.dataset.variantId;
        if (!variant_id) return;
        this.selected_variant = this.product.variants.find(v => v.id == variant_id);
        this.$el.querySelectorAll('[name="id"]').forEach(input => input.value = this.selected_variant.id);
        document.dispatchEvent(new CustomEvent('variant:changed', { detail: { 
          variant: this.selected_variant,
          variantId: this.selected_variant.id
        }}));
      });
    }
  }));
});